// == Unichat Extension ==
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import BrandingIndex from '../views/branding/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/unichat/branding'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'unichat_branding',
          component: BrandingIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
